"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var ImagePicker = function ImagePicker(props) {
  var trigger = props.trigger,
    onChange = props.onChange;
  var value = _typeof(props.value) === 'object' ? props.value.id : props.value;
  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "Select image",
    size: "large",
    trigger: trigger,
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.AssetPicker, _extends({
        globalFilter: "image",
        render: function render(_ref2) {
          var body = _ref2.body,
            selectedFile = _ref2.selectedFile;
          return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              marginTop: '1em'
            }
          }, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary",
            disabled: !selectedFile,
            onClick: function onClick() {
              onChange(selectedFile);
              closeModal();
            }
          }, "Select image")));
        }
      }, value && {
        initialSelectedFile: value
      }));
    }
  });
};
ImagePicker.propTypes = {
  trigger: _propTypes["default"].node,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].object]),
  onChange: _propTypes["default"].func
};
ImagePicker.defaultProps = {
  trigger: /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary"
  }, "Select image")
};
var _default = exports["default"] = ImagePicker;